<div class="page-title mb-4">
    <!-- TO DO translate -->
    {{'Fleet Performance Hub' | translate}}
</div>

<img class="img-fluid" src="assets/img/demo-dashboard/fleet-performance-hub/dashboard-fleet-performance-hub.png"/>
